<template>
  <div :class="['my-app__root', (isNoApp || !isLogin) && 'no-content']">
    <div class="my-app-header">
      <span class="title">我的应用</span>
      <my-app-dropdown
        v-if="!(isNoApp || isTwoRowAppList)"
        :isFold="isFold"
        @toggle-folder="toggleIsFolder"
      ></my-app-dropdown>
    </div>

    <template v-if="isDataInitLoading">
      <my-app-skeleton></my-app-skeleton>
    </template>

    <div :class="['my-app__content', isDataInitLoading && 'skeleton-loading']">
      <template v-if="!isDataInitLoading && isNoApp">
        <my-app-none></my-app-none>
      </template>
      <template v-else-if="!isDataInitLoading">
        <my-app-card-list
          :appList="appList"
          :isFold="isFold"
          @on-is-two-row-app-list="onIsTwoRowAppList"
          @on-reload-my-app-list="setAppList"
        ></my-app-card-list>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getWorkbenchEmitter } from '@/features/workbench-info/workbench-info.tools';
import { usePTeamStore, usePUserStore } from '@/store';
import { computed, defineAsyncComponent, onMounted, PropType, provide, ref, watch } from 'vue';
import myAppCardList from './my-app-card-list.vue';
import { dwMyAppShow } from './my-app-dw';
import myAppSkeleton from './my-app-skeleton.vue';
import { getMyAppEmitter, MyAppEmitterKey, MY_APP_EMITTER } from './my-app.tools';
import { useWMyAppDropdown } from './use-w-my-app-dropdown';

const props = defineProps({
  /** emitter name 解决组件多处复用 */
  emitterName: {
    type: String as PropType<MyAppEmitterKey>,
    default: MY_APP_EMITTER,
  },
});

provide('emitterName', props.emitterName);

const userStore = usePUserStore();

const { isFold, toggleIsFolder } = useWMyAppDropdown();

const isLogin = computed(() => {
  return userStore.isLogin;
});

// const isUserinfoReady = computed(() => {
//   return userStore.isReady;
// });

/** 左上角的下拉 */
const myAppDropdown = defineAsyncComponent({
  loader: () => import('./my-app-dropdown.vue'),
});

/** 应用数为空 */
const myAppNone = defineAsyncComponent({
  loader: () => import('./my-app-none.vue'),
});

/** 数据请求状态 */
const teamStore = usePTeamStore();
/** 数据初始化中 */
const isDataInitLoading = computed(() => {
  return !teamStore.isInitStaticsData;
});

watch(
  () => isDataInitLoading.value,
  (val) => {
    if (!val) {
      // 数据初始化后，判断是否展示我的应用，上报对应埋点
      !isNoApp.value && dwMyAppShow();
    }
  }
);

/** 应用列表 */
const appList = computed(() => {
  return teamStore.statics?.team_apps || [];
});
/** app数量为空 */
const isNoApp = computed(() => {
  return !appList.value?.length;
});
/** 设置app列表 */
const workbenchEmitter = getWorkbenchEmitter();
const setAppList = () => {
  workbenchEmitter.emit('get-team-config');
};

const emitter = getMyAppEmitter(props.emitterName);
// /** 监听app删除emit事件  */
// const onAppDel = () => {
//   emitter.on('on-my-app-del', (data) => {
//     if (!data) {
//       return;
//     }

//     // 请求工作区权益，包含应用数据
//     workbenchEmitter.emit('get-team-config');

//     // const index = appList.value.findIndex((item) => {
//     //   return item.third_app_id === data?.third_app_id && item.platform_id === data?.platform_id;
//     // });
//     // if (index !== -1) {
//     //   appList.value.splice(index, 1);
//     // }
//   });
// };

const onAppListUpdate = () => {
  emitter.on('on-my-app-list-update', () => {
    setAppList();
  });
};

/** 绑定所有emit事件 */
const bindEmit = () => {
  // onAppDel();
  onAppListUpdate();
};

const isTwoRowAppList = ref(true);
const onIsTwoRowAppList = (val: boolean) => {
  isTwoRowAppList.value = val;
};

onMounted(() => {
  bindEmit();
});
</script>

<style lang="scss" scoped>
.my-app {
  $base-height: 138px;
  &__root {
    min-height: $base-height;
    width: 100%;
    background-color: var(--lowcode-background-01);
    border-radius: 8px;
    flex-grow: 1;
    flex-shrink: 0;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 0 18px;
    box-sizing: border-box;
    &::before {
      position: absolute;
      content: '';
      top: -15px;
      left: 0;
      right: 0;
      height: 153px;
      border-radius: 8px;
      background-color: var(--lowcode-background-01);
      z-index: -1;
    }

    &.no-content {
      height: 142px;
    }
  }

  &-header {
    padding-left: 8px;
    display: flex;

    .title {
      height: 22px;
      font-size: 14px;
      font-weight: bold;
      color: var(--lowcode-text-03);
      line-height: 22px;
      flex: 1;
    }
  }

  &__content {
    padding-bottom: 14px;
  }
}
</style>
